<template>
  <div class="blank-layout-wrapper">
    <router-view />

    <!-- 全局智能助手浮动按钮 -->
    <!-- <AIAssistantFloatBtn /> -->

    <!-- 全局智能助手弹窗 -->
    <a-modal
      title="合汇科技智能助手"
      :width="900"
      :visible="aiAssistantVisible"
      :footer="null"
      :maskClosable="true"
      :closable="false" 
      :centered="true"
      :zIndex="10002"
      @cancel="aiAssistantVisible = false"
      class="ai-assistant-modal"
      :body-style="{ padding: 0, height: '70vh', overflow: 'hidden' }"
    >
      <agent-chat :app-id="agentAppId" @close="aiAssistantVisible = false" />
    </a-modal>
  </div>
</template>

<script>
import AgentChat from '@/components/AIAssistant/AgentChat'
import AIAssistantFloatBtn from '@/components/AIAssistant/AIAssistantFloatBtn'

export default {
  name: 'BlankLayout',
  components: {
    AgentChat,
    AIAssistantFloatBtn
  },
  data() {
    return {
      aiAssistantVisible: false,
      agentAppId: '061bdd3fd89f4992bb96604b8161ef97' // 智能体应用ID
    }
  },
  watch: {
    aiAssistantVisible(newVal) {
      // 当弹窗打开时,禁用 body 和 html 的滚动;关闭时恢复
      if (newVal) {
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        document.documentElement.style.overflow = ''
      }
    }
  },
  mounted() {
    // 监听显示智能助手事件(从BasicLayout触发)
    this.$root.$on('show-ai-assistant', () => {
      this.aiAssistantVisible = true
    })
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('show-ai-assistant')
    // 确保销毁时恢复 body 和 html 滚动
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.blank-layout-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 智能助手弹窗样式 */
/deep/ .ai-assistant-modal {
  .ant-modal-wrap {
    z-index: 10002 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .ant-modal-mask {
    z-index: 10002 !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .ant-modal {
    z-index: 10002 !important;
    padding-bottom: 0;
    position: relative;
    max-height: none;
    overflow: visible;
  }

  .ant-modal-content {
    height: 70vh;
    max-height: calc(90vh - 40px);
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
    position: relative;
    background: transparent !important; /* Make transparent for glass effect */
    box-shadow: none !important; /* Remove default shadow */
  }

  /* 隐藏默认头部 */
  .ant-modal-header {
    display: none;
  }

  /* 自定义关闭按钮样式 */
  .ant-modal-close {
    top: 0;
    right: 0;
    height: 55px;
    width: 55px;
    z-index: 10;

    .ant-modal-close-x {
      height: 55px;
      line-height: 55px;
      color: #fff;
      font-size: 18px;
    }

    &:hover .ant-modal-close-x {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .ant-modal-body {
    flex: 1;
    padding: 0 !important;
    overflow: hidden !important;
    height: 100% !important;
    max-height: none !important;
  }

  .agent-chat-container {
    height: 100%;
    overflow: hidden;

    .ant-card {
      height: 100%;
      border: none;
      box-shadow: none;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .ant-card-head {
        border-bottom: none;
        padding: 0 16px;
        flex-shrink: 0;
        height: 55px;

        .ant-card-head-wrapper {
          height: 100%;
          display: flex;
          align-items: center;
        }

        .ant-card-head-title {
          font-size: 18px;
          font-weight: 600;
          color: #fff;
          padding: 0;
        }
      }

      .ant-card-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 !important;
        overflow: hidden !important;
        height: auto;
      }
    }
  }
}
</style>
